// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { NavigationServiceType, NavigationSlot } from '@service/navigation';
import { Inject } from '@plugin/inversify';
import { ErrorDetails } from '@component/ErrorDetails/ErrorDetails.vue';
import { Footer } from '@component/Footer/Footer.vue';
import { Layout } from '@component/Layout/Layout.vue';
import { Navbar } from '@component/Navbar/Navbar.vue';
import { BottomBar } from '@component/BottomBar/BottomBar.vue';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let DefaultLayout = class DefaultLayout extends Vue {
    get footerBottomNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.FooterBottom)
            ? ((_a = this.navigation.getSlot(NavigationSlot.FooterBottom)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get footerTopNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.FooterTop)
            ? ((_a = this.navigation.getSlot(NavigationSlot.FooterTop)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get hasErrors() {
        return this.$errorHandler.error !== null;
    }
    get routeName() {
        if (!this.$route.name) {
            return '';
        }
        return this.$route.name;
    }
    /**
     * Determines whether `Subscribe` button should be visible or not
     */
    get shouldRenderSubscriptionBtn() {
        return this.navigation.getSubscriptionButtonState();
    }
    get premiumButtonLink() {
        return this.navigation.getPremiumButtonLink() || '';
    }
    get videoButtonLink() {
        return this.navigation.getVideoButtonLink() || '';
    }
    get sideNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.Left)
            ? ((_a = this.navigation.getSlot(NavigationSlot.Left)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get socialNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.Social)
            ? ((_a = this.navigation.getSlot(NavigationSlot.Social)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get topNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.Top)
            ? ((_a = this.navigation.getSlot(NavigationSlot.Top)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get subTopNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.SubTop)
            ? ((_a = this.navigation.getSlot(NavigationSlot.SubTop)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get mobileNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.MobileBar)
            ? ((_a = this.navigation.getSlot(NavigationSlot.MobileBar)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get sitesNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.RelatedSites)
            ? ((_a = this.navigation.getSlot(NavigationSlot.RelatedSites)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get topBarNav() {
        var _a;
        return this.navigation.hasSlot(NavigationSlot.TopBar)
            ? ((_a = this.navigation.getSlot(NavigationSlot.TopBar)) === null || _a === void 0 ? void 0 : _a.links) || [] : [];
    }
    get queryParams() {
        return this.$route.query;
    }
    /**
     * Determine if Layout uses Sidebar.
     */
    static hasSidebar() {
        return true;
    }
    setAdTargeting(targeting) {
        this.$emit('setAdTargeting', targeting);
    }
};
__decorate([
    Inject(NavigationServiceType)
], DefaultLayout.prototype, "navigation", void 0);
DefaultLayout = __decorate([
    Component({
        name: 'DefaultLayout',
        components: {
            ErrorDetails,
            BottomBar,
            Footer,
            Layout,
            Navbar
        },
        template: `
    <Layout>
      <template #top>
        <Navbar :links="topNav" :subLinks="subTopNav" :sitesLinks="topBarNav"
                :showSubscriptionBtn="shouldRenderSubscriptionBtn"
                :premiumButtonLink="premiumButtonLink" :videoButtonLink="videoButtonLink" />

        <BottomBar :links="mobileNav" />
      </template>

      <template #middle>
        <slot>
          <ErrorDetails v-if="hasErrors" />
          <router-view v-else :key="$route.fullPath" @setAdTargeting="setAdTargeting" />
        </slot>
      </template>

      <template #bottom>
        <Footer
          :topLinks="footerTopNav"
          :bottomLinks="footerBottomNav"
          :sitesLinks="sitesNav"
          :socialLinks="socialNav"
        />
      </template>
    </Layout>
  `
    })
], DefaultLayout);
export { DefaultLayout };
